export interface GalleryItem {
  type: "image" | "video";
  url: string;
  /** Optional poster frame for videos (Cloudinary can auto-generate one - see notes) */
  thumbnail?: string;
  caption?: string;
}

export interface Project {
  id: string;
  title: string;
  category: string;
  description: string;
  /** Cover image - used on the /work grid and as a fallback poster for the video */
  image: string;
  /** Optional cover video (Cloudinary .mp4/.webm) - plays on card hover + autoplays on the detail hero */
  video?: string;
  /** Extra images/videos shown in the detail page gallery + lightbox */
  gallery?: GalleryItem[];
  /** Client/brand mark, shown as a small chip on the card + detail header */
  logo?: string;
  /** Single hex used sparingly per project (status dot, stat numbers) - pick something grounded in the project's domain */
  accentColor: string;
  solution: string;
  industry: string;
  year: string;
  duration?: string;
  /** Link to the live product - renders a "Visit live project" CTA + swaps the status pill to "Live" */
  liveUrl?: string;
  /** Give at most one project this per filter view - it gets the wide, split hero treatment */
  featured?: boolean;
  challenge: string;
  approach: string;
  results: string[];
  techStack: string[];
}

export const projects: Project[] = [
  {
    id: "tarang",
    title: "Tarang - FRA Application",
    category: "Digital India Initiative",
    description:
      "Forest Rights Act (FRA) Management System for digitizing and managing tribal land rights claims in India.",
    image:
      "https://res.cloudinary.com/zeqof4ic/image/upload/v1783775472/Screenshot_2026-07-11_182948_nwqyxx.png",
    video:
      "https://res.cloudinary.com/zeqof4ic/video/upload/v1783775460/Screen_Recording_2026-07-11_183945_p3a6jx.mp4",
    gallery: [
      {
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783775472/Screenshot_2026-07-11_182948_nwqyxx.png",
        caption: "Landing Page",
      },
      {
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783775473/Screenshot_2026-07-11_183005_zn0mbg.png",
        caption: "Landing Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783775475/Screenshot_2026-07-11_183109_scwvdl.png",
        caption: "RAG Chatbot",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783775476/Screenshot_2026-07-11_183055_p7tdac.png",
        caption: "Offical Login Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783775476/Screenshot_2026-07-11_183459_p0yxls.png",
        caption: "Forest Dashboard",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783775477/Screenshot_2026-07-11_183512_osmcao.png",
        caption: "Forest Claims Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783775479/Screenshot_2026-07-11_183546_pcqhmd.png",
        caption: "GIS-based forest rights atlas",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783775480/Screenshot_2026-07-11_183607_h0skwa.png",
        caption: "GIS Map",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783775480/Screenshot_2026-07-11_183734_kb9r0z.png",
        caption: "MOTA Dashboard",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783775481/Screenshot_2026-07-11_183756_nncvsa.png",
        caption: "Scheme Gallery",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783780270/WhatsApp_Image_2026-07-11_at_7.58.24_PM_2_kazxta.jpg",
        caption: "Mobile Home Screen",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783780270/WhatsApp_Image_2026-07-11_at_7.58.24_PM_1_qvxfja.jpg",
        caption: "Mobile Login Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783780272/WhatsApp_Image_2026-07-11_at_7.58.24_PM_fvlywk.jpg",
        caption: "List of Claims",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783780269/WhatsApp_Image_2026-07-11_at_7.58.23_PM_oyovi1.jpg",
        caption: "Map",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783780267/WhatsApp_Image_2026-07-11_at_7.58.23_PM_3_b2je7m.jpg",
        caption: "Mobile Screen",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783780267/WhatsApp_Image_2026-07-11_at_7.58.23_PM_2_bv4hou.jpg",
        caption: "Mobile App Screen",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783780266/WhatsApp_Image_2026-07-11_at_7.58.23_PM_1_gvexz2.jpg",
        caption: "Mobile app Sidebar",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783780266/WhatsApp_Image_2026-07-11_at_7.58.22_PM_he42eq.jpg",
        caption: "Mobile Profile Page",
      },
    ],
    logo: "https://tarang-eight.vercel.app/assets/Tarang_Logo_new-DoMwrqPA.png",
    accentColor: "#10B981",
    solution: "Web & Mobile Application",
    industry: "Government of India",
    year: "2026",
    duration: "2 Years",
    liveUrl: "N/A",
    featured: true,
    challenge:
      "The Ministry needed a robust, scalable system to manage forest rights applications (FRA) across remote tribal areas with intermittent connectivity. The system had to handle massive concurrent traffic during peak application periods.",
    approach:
      "We architected a distributed cloud solution using microservices for scalability. The backend includes dedicated ML services powered by FastAPI for intelligent processing. We implemented offline-first capabilities for the mobile app to ensure data collection in remote areas, syncing automatically when connectivity is restored.",
    results: [
      "Processed over 2 million applications seamlessly.",
      "Reduced application processing time by 60%.",
      "Enabled 100% data accuracy through digitized workflows.",
    ],
    techStack: ["React", "Node.js", "PostgreSQL", "Redis", "Docker", "Kubernetes", "FastAPI"],
  },
  {
    id: "samku-ev-services",
    title: "Samku EV Services",
    category: "Web Application",
    description: "Samku Services is a comprehensive EV (Electric Vehicle) charging station management platform built with the MERN stack (MongoDB, Express.js, React.js, Node.js). The system provides end-to-end solutions for managing EV charging stations, including installations, maintenance services, and an online store for EV-related products.",
    image:
      "https://res.cloudinary.com/zeqof4ic/image/upload/v1783773984/Screenshot_2026-06-29_105127_d7hcwg.png",
    video:
      "https://res.cloudinary.com/zeqof4ic/video/upload/v1783772469/Screen_Recording_2026-07-11_175002_uabijy.mp4",
    gallery: [
      {
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772524/Screenshot_2026-07-11_173845_brpegv.png",
        caption: "Landing Page Hero Section",
      },
      {
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772525/Screenshot_2026-07-11_173918_m4o4jx.png",
        caption: "Home Quick Services Section",
      },
      {
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772526/Screenshot_2026-07-11_174014_nuzi9b.png",
        caption: "Charging Station Map",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772526/Screenshot_2026-07-11_174045_wrj7rr.png",
        caption: "Main Services Page to book services",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772527/Screenshot_2026-07-11_174110_apiqi2.png",
        caption: "Franhcise and charging station application page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772524/Screenshot_2026-06-29_105104_g04ajs.png",
        caption: "EV Store",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772518/Screenshot_2026-06-29_103511_yiclkp.png",
        caption: "Admin Dashboard",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772519/Screenshot_2026-06-29_103550_fgxw7s.png",
        caption: "Inventory Management",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772520/Screenshot_2026-06-29_103612_n9lwvg.png",
        caption: "Barcode Generator",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772520/Screenshot_2026-06-29_103640_wg0euf.png",
        caption: "Admin Booked services page list",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772521/Screenshot_2026-06-29_103655_yyzdyz.png",
        caption: "Franchise Management",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772522/Screenshot_2026-06-29_104900_ql3qqv.png",
        caption: "Franchise Dashboard",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772522/Screenshot_2026-06-29_104916_hualql.png",
        caption: "Franchise Stock Request Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772523/Screenshot_2026-06-29_104939_qxjzey.png",
        caption: "Technician Management",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772528/Screenshot_2026-07-11_174319_quib0y.png",
        caption: "EV Service booking Steps",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772529/Screenshot_2026-07-11_174401_eofcry.png",
        caption: "EV Service booking Steps",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772530/Screenshot_2026-07-11_174425_uoik4l.png",
        caption: "Payment Gateway Integration",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772530/Screenshot_2026-07-11_174533_m2shji.png",
        caption: "Website content management system",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783772532/Screenshot_2026-07-11_174651_pt4rgb.png",
        caption: "Admin User Management",
      },
    ],
    logo: "https://samkueservices.com/assets/logo-CAbd_T8i.png",
    accentColor: "#F59E0B",
    solution: "Full Stack Web Application",
    industry: "EV & Logistics",
    year: "2024",
    duration: "8 months",
    liveUrl: "https://samkueservices.com",
    challenge:
      "Samku EV needed to optimize their battery swapping and logistics network. Manual routing was inefficient, leading to high operational costs and delays.",
    approach:
      "We developed a custom logistics platform integrated with a proprietary neural network to predict demand and optimize routes in real-time. The system tracks battery health and location to ensure optimal fleet performance.",
    results: [
      "25% reduction in logistics costs.",
      "30% improvement in delivery times.",
      "99.9% uptime for the logistics management system.",
    ],
    techStack: ["Next.js", "Python", "TensorFlow", "FastAPI", "MongoDB"],
  },
  {
    id: "samku-ev-ecommerce",
    title: "Samku EV E-Commerce",
    category: "E-Commerce",
    description: "Immutable transaction layers for institutional digital assets in the EV market.",
    image:
      "https://res.cloudinary.com/zeqof4ic/image/upload/v1783781267/Screenshot_2026-07-11_201224_bejnvj.png",
    video:
      "https://res.cloudinary.com/zeqof4ic/video/upload/v1783781252/Screen_Recording_2026-07-11_201639_gkd2mc.mp4",
    gallery: [
      {
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783781263/Screenshot_2026-07-11_201124_z0cmlw.png",
        caption: "Landing Page",
      },
      {
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783781265/Screenshot_2026-07-11_201138_bv1a9h.png",
        caption: "Product Details Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783781266/Screenshot_2026-07-11_201212_sxcgzb.png",
        caption: "Charger Product Details Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783781267/Screenshot_2026-07-11_201224_bejnvj.png",
        caption: "Chargers Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783781268/Screenshot_2026-07-11_201248_eytvpe.png",
        caption: "Main Product Category Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783781269/Screenshot_2026-07-11_201308_mdexo4.png",
        caption: "Main Product Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783781271/Screenshot_2026-07-11_201334_a3xt2t.png",
        caption: "Product Details Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783781776/samkuevc_qegztz.jpg",
        caption: "Admin Home Landing page management",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783781846/samkuev_zvoy55.jpg",
        caption: "Admin Product Query Page",
      },
    ],
    logo: "https://samkueservices.com/assets/logo-CAbd_T8i.png",
    accentColor: "#6366F1",
    solution: "Distributed Ledger",
    industry: "Financial Services",
    year: "2023",
    duration: "6 months",
     liveUrl: "https://samkuev.com",
    challenge:
      "There was a lack of trust and transparency in the secondary market for EV components. Institutional buyers needed a secure way to verify asset history and ownership.",
    approach:
      "We built a blockchain-backed e-commerce platform that records every transaction on an immutable ledger. This ensures complete traceability of components from manufacturer to end-user.",
    results: [
      "Facilitated over $10M in secure transactions.",
      "Eliminated counterfeit components from the marketplace.",
      "Built trust with major institutional partners.",
    ],
    techStack: ["React", "Solidity", "Ethereum", "Web3.js", "AWS"],
  },
  {
    id: "educore",
    title: "EduCore - School Management System",
    category: "Management System",
    description:
      "A comprehensive, production-ready mobile education management app built with React Native and Node.js. Similar to Google Classroom with Udemy-style courses and Google Forms-style quizzes.",
    image:
      "https://res.cloudinary.com/zeqof4ic/image/upload/v1783784032/WhatsApp_Image_2026-07-11_at_9.02.13_PM_rxj6pz.jpg",
    video:
      "https://res.cloudinary.com/zeqof4ic/video/upload/v1783787555/educorevideo_mf0p37.mp4",
    gallery: [
      {
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783784031/WhatsApp_Image_2026-07-11_at_9.02.13_PM_1_imqvyu.jpg",
        caption: "Create account page",
      },
      {
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783784032/WhatsApp_Image_2026-07-11_at_9.02.13_PM_rxj6pz.jpg",
        caption: "Login Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783784031/WhatsApp_Image_2026-07-11_at_9.02.13_PM_2_zl07de.jpg",
        caption: "Teacher Dashboard",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783784328/WhatsApp_Image_2026-07-11_at_9.02.14_PM_2_nrxoz1.jpg",
        caption: "Teacher Student list",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783784328/WhatsApp_Image_2026-07-11_at_9.02.14_PM_xuoxml.jpg",
        caption: "Teacher Profile Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783784333/WhatsApp_Image_2026-07-11_at_9.02.15_PM_3_phuw3m.jpg",
        caption: "Techer Course Screen",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783784330/WhatsApp_Image_2026-07-11_at_9.02.15_PM_1_jn0cs8.jpg",
        caption: "Teacher Assignment Add Screen",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783784331/WhatsApp_Image_2026-07-11_at_9.02.15_PM_2_bvz3ll.jpg",
        caption: "New assignment Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783784334/WhatsApp_Image_2026-07-11_at_9.02.15_PM_s9fivz.jpg",
        caption: "Add Student Process",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783784336/WhatsApp_Image_2026-07-11_at_9.02.16_PM_1_s3pbfr.jpg",
        caption: "Student Course Screen",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783784341/WhatsApp_Image_2026-07-11_at_9.02.17_PM_1_pcl81r.jpg",
        caption: "Teacher Add Quize Screen",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783784342/WhatsApp_Image_2026-07-11_at_9.02.17_PM_2_dvk4eq.jpg",
        caption: "Student Dashboard",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783784347/WhatsApp_Image_2026-07-11_at_9.02.18_PM_1_kuc2et.jpg",
        caption: "New Assingment Add Screen",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783784352/WhatsApp_Image_2026-07-11_at_9.02.19_PM_1_duhobt.jpg",
        caption: "Admin / HOD Dashboard",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783780267/WhatsApp_Image_2026-07-11_at_7.58.23_PM_2_bv4hou.jpg",
        caption: "Mobile App Screen",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783784353/WhatsApp_Image_2026-07-11_at_9.02.19_PM_2_ixojt8.jpg",
        caption: "Admin Analytics Screen",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783784356/WhatsApp_Image_2026-07-11_at_9.02.20_PM_1_hjcnbb.jpg",
        caption: "List of Teachers Admin Screen",
      },
    ],
    logo: "https://play-lh.googleusercontent.com/907R7QSxZnRoc6q00p6MplPYOyqBhD52kCSI3CCHH9cZ9otSbeXztDuQq_-M-XwAY5MYqvLeEKAWITBzfcruLw=w480-h960-rw",
    accentColor: "#10B981",
    solution: "Mobile Application",
    industry: "Public School",
    year: "2025",
    duration: "1 Years",
    featured: false,
    challenge: "The school needed a mobile app to manage their students, teachers, and courses. The app needed to be able to handle a large number of students and teachers, and needed to be able to handle a large number of courses and assignments.",
    approach:
      "We architected a distributed cloud solution using microservices for scalability. The backend includes dedicated ML services powered by FastAPI for intelligent processing. We implemented offline-first capabilities for the mobile app to ensure data collection in remote areas, syncing automatically when connectivity is restored.",
    results: [
      "100% student engagement through the app.",
      "90% teacher productivity through the app.",
      "95% course completion rate through the app.",
    ],
    techStack: ["ReactNative", "Node.js", "PostgreSQL", "Redis", "Docker", "Kubernetes", "FastAPI"],
  },
  {
    id: "aquamrut",
    title: "Aquamrut - Water Treatment Plant Management System",
    category: "Water Services",
    description: "Aquaamrut is a premier industrial water treatment company delivering precision-engineered purification systems across India. From compact household RO units to large-scale industrial treatment plants, we combine advanced membrane technology with deep engineering expertise.",
    image:
      "https://res.cloudinary.com/zeqof4ic/image/upload/v1783785594/Screenshot_2026-07-11_212113_rdgt2n.png",
    video:
      "https://res.cloudinary.com/zeqof4ic/video/upload/v1783785585/Screen_Recording_2026-07-11_212714_kyhg8z.mp4",
    gallery: [
      {
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783785594/Screenshot_2026-07-11_212113_rdgt2n.png",
        caption: "Landing Page",
      },
      {
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783785597/Screenshot_2026-07-11_212406_kopplg.png",
        caption: "Product Details Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783785599/Screenshot_2026-07-11_212423_nf1qyt.png",
        caption: "Water Service Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783785600/Screenshot_2026-07-11_212444_wfhab3.png",
        caption: "Product Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783785602/Screenshot_2026-07-11_212502_o1mgto.png",
        caption: "Solution Page",
      },{
        type: "image",
        url: "https://res.cloudinary.com/zeqof4ic/image/upload/v1783785604/Screenshot_2026-07-11_212529_gagwch.png",
        caption: "Solution List Page",
      }
    ],
    logo: "https://www.aquaamrut.in/assets/aqua1-CxnVH6gE.webp",
    accentColor: "#6366F1",
    solution: "Web Application",
    industry: "Water Treatment Services",
    year: "2023",
    duration: "6 months",
     liveUrl: "https://www.aquaamrut.in",
    challenge:
      "Aquaamrut needed a web application to manage their water treatment plants and services. The application needed to be able to handle a large number of plants and services, and needed to be able to handle a large number of customers and orders.",
    approach:
      "We built a web application that allows Aquaamrut to manage their water treatment plants and services. The application includes a dashboard for managing the plants and services, a form for adding new plants and services, and a list of all the plants and services.",
    results: [
      "100% plant management through the application.",
      "90% service management through the application.",
      "95% customer management through the application.",
    ],
    techStack: ["React", "Node.js", "PostgreSQL", "Redis", "Docker", "Kubernetes", "FastAPI"],
  }
];